<template>
  <div>
    <div class="auth">
      <div class="grayHead">
        <span>
          メールアドレスを入力してください。入力したメールアドレスのメールに認証コードを送信します。
        </span>
      </div>
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        name="userLoginForm"
        class="form"
        @submit.prevent="validateBeforeSubmit()"
      >
        <InputText
          v-model="inputData.mail"
          :vid="'mail'"
          :label="'メールアドレス'"
          :type="'email'"
          :maxlength="255"
          rules="required|email|max:255"
          class="form__group"
        />

        <!-- Submit Button -->
        <div class="form__group mt72">
          <Btn
            :label="'送信'"
            :color="'red'"
            :disabled="invalid || isLoading"
            :type="'submit'"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import error from '@/mixin/error.mixin'
import redirect from '@/mixin/redirect.mixin'
import store from '@/store'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'

export default {
  name: 'AccountCreateStep01Mail',

  mixins: [
    // APIエラーメッセージ
    error,
    // リダイレクト ※ GETパラメータ (redirecturl, backurl)
    redirect
  ],

  components: {
    InputText,
    Btn
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  data () {
    return {
      inputData: {
        mail: ''
      }
    }
  },

  computed: {
    ...mapGetters(['isLoading'])
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.submit()
      }
    },

    submit () {
      this.$store.commit('loadingAction', true)
      this.$store.dispatch('accountCreate/sendRegisterMail', this.inputData)
        .then(_res => {
          this.$router.push({
            name: 'AccountCreateStep02Code',
            params: { id: _res.code_request_id }
          }).catch(() => {})
        }).catch((err) => {
          this.$store.commit('loadingAction', false)
          this.addValidateErrors(this.$refs.observer, err)
        })
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import '../../assets/css/form.pcss';
</style>



// WEBPACK FOOTER //
// src/pages/account-create/Step01Mail.vue